<template>
    <div class="form-field">
        <label>颜色</label>
        <div class="content">
            <el-color-picker color-format="hex" :value="style.color" @active-change="setColor"/>
        </div>
    </div>
</template>

<script>
	import style from 'mixins/style'

	export default {
		mixins: [ style ],
		data() {
			return {
				value: null
			}
		},
		computed: {
			selected() {
				return this.$store.state.selected
			},
			style() {
				return this.$store.state.selected && this.$store.state.selected.style || {}
			},
			color() {
				return this.style.color
			}
		},
		methods: {
			setColor(color) {
				this.$store.commit('update_action_style', {
					id: this.selected.id,
					textProp: {
						color: color
					}
				})

			}
		}
	}
</script>
